import * as Models from "../.";
export interface IGetUserResponse {
  successful: boolean;
  message: string;
  user: Models.UserModel.IUserModel;
}

export class GetUserResponse implements IGetUserResponse {
  successful: boolean;
  message: string;
  user: Models.UserModel.IUserModel;
}
